export default "__VITE_ASSET__WwkCw3GccWPOqB3GrtMoWA__";